import { pcaa } from "area-data";
import _ from "lodash";

const AREA_DATA_MAP = _.mapValues(pcaa, area => {
    return _.map(area, (text, code) => {
        return { code: code, text: text };
    });
});

function findByCode(areas, code) {
    return _.find(areas, area => {
        return area["code"] === code;
    });
}

export function allProvincial() {
    return AREA_DATA_MAP["86"];
}

export function subAreas(parent) {
    return AREA_DATA_MAP[parent["code"]];
}

export function findAreas(provincialCode, cityCode, districtCode) {
    const provincialArea = findByCode(allProvincial(), provincialCode);
    const cityArea = findByCode(subAreas(provincialArea), cityCode);
    const districtArea = findByCode(subAreas(cityArea), districtCode);
    return [provincialArea, cityArea, districtArea];
}
